import { FC } from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Divider } from '@mui/material';

import { IMedicationAdditionalCardProps } from './AdditionalInformationCard.interface';

import './style.scss';

const AdditionalInformationCard: FC<IMedicationAdditionalCardProps> = ({
  drugClassIds,
  conditions,
  synonyms,
  medicationDetails,
}): JSX.Element => (
  <Box className="additional-info-card">
    <div className="additional-info-card__title">Additional Information</div>

    <Divider flexItem />
    {!medicationDetails ? (
      <div className="additional-info-card__default-text">
        Additional information, if any, will be displayed here.
      </div>
    ) : (
      <div className="additional-info-card__card-body">
        <div className="additional-info-card__section">
          <div className="additional-info-card__subtitle">Synonyms</div>
          <div className="additional-info-card__text">
            {synonyms?.length ? synonyms.join(', ') : '-'}
          </div>
        </div>

        <div className="additional-info-card__section">
          <div className="additional-info-card__subtitle">Drug Classes</div>
          <div className="additional-info-card__text">
            {drugClassIds?.length ? drugClassIds.join(', ') : '-'}
          </div>
        </div>

        <div className="additional-info-card__section">
          <div className="additional-info-card__subtitle">Conditions</div>
          <div className="additional-info-card__text">
            {conditions?.length ? (
              <div className="additional-info-card__conditions">
                <span className="additional-info-card__icon-wrapper">
                  <WarningIcon />
                </span>
                {conditions}
              </div>
            ) : (
              '-'
            )}
          </div>
        </div>
      </div>
    )}
  </Box>
);

export default AdditionalInformationCard;
